import styled from "styled-components";
import { PagesAccountHierarchyUiInput } from "./Input";
import { PagesAccountHierarchyUiResults } from "./Results";
import type { accountHierarchyAPIInterface } from "@dealer-center/ddc-pages-account-hierarchy-interface";

const StyledPagesAccountHierarchyUi = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

const StyledPageHeader = styled.h1`
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 1rem;
`;

interface PagesAccountHierarchyUiDisplayProps {
  setName: (name: string) => void;
  data?: accountHierarchyAPIInterface;
  error?: string;
  loading: boolean;
  nameInput: string;
  setNameInput: (name: string) => void;
}

export const PagesAccountHierarchyUiDisplay = ({
  data,
  nameInput,
  setName,
  setNameInput,
  error,
  loading
}: PagesAccountHierarchyUiDisplayProps) => {
  return (
    <StyledPagesAccountHierarchyUi>
      <StyledPageHeader>Welcome to accountHierarchy-react!</StyledPageHeader>
      <PagesAccountHierarchyUiInput
        loading={loading}
        nameInput={nameInput}
        setName={setName}
        setNameInput={setNameInput}
      />
      <PagesAccountHierarchyUiResults data={data} error={error} />
    </StyledPagesAccountHierarchyUi>
  );
};
